import React, { useState, useRef, useContext } from "react";
import { OutTable, ExcelRenderer } from "react-excel-renderer";
import * as XLSX from "xlsx";
import {
  Col,
  Input,
  InputGroup,
  InputGroupAddon,
  FormGroup,
  Button,
  Fade,
  FormFeedback,
  Container,
  Card,
} from "reactstrap";

import { fixtureContext } from "../context/FixtureContext";
import Breadcrumbs from "@mui/material/Breadcrumbs";
import Link from "@mui/material/Link";
import useLoginfo from "../../utils/useLoginfo";
import { useHistory } from "react-router-dom";

const ImportPlanogram = () => {
  const { submitAssortmentPlanogramAction } = useContext(fixtureContext);

  const history = useHistory()
  //OKTA
  const { tokenVal } = useLoginfo()

  const [dataLoaded, setdataLoaded] = useState(false);
  const [isFormInvalid, setisFormInvalid] = useState(false);
  const [rows, setrows] = useState(null);
  const [cols, setcols] = useState(null);
  const [imp, setimp] = useState([]);
  const [uploadedFileName, setuploadedFileName] = useState("");

  const fileInput = useRef();

  const renderFile = (fileObj) => {
    //just pass the fileObj as parameter
    ExcelRenderer(fileObj, (err, resp) => {
      // console.log(resp);
      if (err) {
        alert(err);
      } else {
        setdataLoaded(true);
        setcols([
          {
            name: "",
            key: 0,
          },
          ...resp.cols.map((element) => {
            return {
              name: element.name,
              key: element.key + 1,
            };
          }),
        ]);
        setrows([...resp.rows]);
      }
    });
  };

  const readExcel = (file) => {
    const promise = new Promise((resolve, reject) => {
      const fileReader = new FileReader();
      fileReader.readAsArrayBuffer(file);

      fileReader.onload = (e) => {
        const bufferArray = e.target.result;

        const wb = XLSX.read(bufferArray, { type: "binary" });

        const wsname = wb.SheetNames[0];

        const ws = wb.Sheets[wsname];

        const data = XLSX.utils.sheet_to_json(ws);

        resolve(data);
      };

      fileReader.onerror = (error) => {
        reject(error);
      };
    });

    promise.then((arr) => {
      setimp(
        arr.map(
          ({
            "Fixture Assortment Number": FIXTURE_NUMBER,
            "Assortment Category": CATEGORY_NAME,
            "Assortment Sub-Category": SUB_CATEGORY_NAME,
            "POG Number": PLANO_NBR,
            "POG Name": PLANO_NAME,
            "Serial Number": SERIAL_NUM,
            Active: ACTIVE,
            "Admin Only": ADMIN_ONLY,
            "Ordering Start Date": START_DATE,
            "Ordering End Date": END_DATE,
            "Lead Time": LEAD_TIME,
            "Fixed time": FIXED_TIME,
            "Max Ship Date": MAX_SHIP_DATE,
            "Min Ship Date": MIN_SHIP_DATE,
            "Assortment Number": ASSORTMENT_NBR,
            "CTB Tool Dept": DEPARTMENT,
            "Markdown %": MARKDOWN,
            Dating: DATING,
            "Availability Flag": AVAILABILITY,
            "LC Ind": LAST_CHANCE,
            "Assortment Name": ASSORTMENT_NAME,
            "Order Missing Allowed": ORDER_MISSING_ALLOWED,
            "Order All Allowed": ORDER_ALL_ALLOWED,
            "Kitted":KITTED
          }) => ({
            DEPARTMENT: DEPARTMENT ? DEPARTMENT.toString().trim() : "",
            MARKDOWN: MARKDOWN ? MARKDOWN.toString() : "0",
            DATING: DATING ? DATING.toString() : "",
            AVAILABILITY: AVAILABILITY ? AVAILABILITY.toString() : "",
            LAST_CHANCE: LAST_CHANCE ? LAST_CHANCE.toString() : "",
            FIXTURE_NUMBER: FIXTURE_NUMBER ? FIXTURE_NUMBER.toString() : "",
            CATEGORY_NAME: CATEGORY_NAME ? CATEGORY_NAME.toString().trim() : "",
            SUB_CATEGORY_NAME: SUB_CATEGORY_NAME
              ? SUB_CATEGORY_NAME.toString().trim()
              : "",
            PLANO_NBR: PLANO_NBR ? PLANO_NBR.toString() : "",
            PLANO_NAME: PLANO_NAME ? PLANO_NAME.toString() : "",
            SERIAL_NUM: SERIAL_NUM ? SERIAL_NUM.toString() : "",
            ACTIVE: ACTIVE ? ACTIVE.toString() : "",
            ADMIN_ONLY: ADMIN_ONLY ? ADMIN_ONLY.toString() : "",
            START_DATE: new Date(Date.UTC(0, 0, START_DATE - 1))
              .toISOString()
              .split("T")[0],
            END_DATE: new Date(Date.UTC(0, 0, END_DATE - 1))
              .toISOString()
              .split("T")[0],
            LEAD_TIME: LEAD_TIME ? LEAD_TIME : 0,
            FIXED_TIME: FIXED_TIME ? FIXED_TIME : 0,
            MAX_SHIP_DATE: new Date(Date.UTC(0, 0, MAX_SHIP_DATE - 1))
              .toISOString()
              .split("T")[0],
            MIN_SHIP_DATE: new Date(Date.UTC(0, 0, MIN_SHIP_DATE - 1))
              .toISOString()
              .split("T")[0],
            ASSORTMENT_NBR: ASSORTMENT_NBR ? ASSORTMENT_NBR : 0,
            ASSORTMENT_NAME: ASSORTMENT_NAME ? ASSORTMENT_NAME.toString().trim() : "",
            ORDER_MISSING_ALLOWED: ORDER_MISSING_ALLOWED ? ORDER_MISSING_ALLOWED.toString() : "",
            ORDER_ALL_ALLOWED: ORDER_ALL_ALLOWED ? ORDER_ALL_ALLOWED.toString() : "",
            KITTED:KITTED? KITTED.toString().trim(): "P"
          })
        )
      );
    });
  };

  const fileHandler = (event) => {
    if (event.target.files.length) {
      let fileObj = event.target.files[0];
      let fileName = fileObj.name;

      //check for file extension and pass only if it is .xlsx and display error message otherwise
      if (fileName.slice(fileName.lastIndexOf(".") + 1) === "xlsx") {
        setuploadedFileName(fileName);
        setisFormInvalid(false);
        renderFile(fileObj);
        readExcel(fileObj);
      } else {
        setuploadedFileName("");
        setisFormInvalid(true);
      }
    }
  };

  const openFileBrowser = (e) => {
    fileInput.current.click();
  };

  const handleImport = (e) => {
    e.preventDefault();
    console.log(imp)
    if (imp.length > 0) {
      submitAssortmentPlanogramAction(imp, tokenVal, history)
      // history.push("/view-planogram");
    }
    else alert("Please browse a file");
  };

  return (
    <div>
      <Breadcrumbs
        separator="›"
        aria-label="breadcrumb"
        style={{ marginLeft: "15px" }}
      >
        <Link underline="hover" color="inherit" href="/view-planogram">
          View Assortment Planogram
        </Link>
        <Link
          underline="hover"
          color="text.primary"
          href="/import-planogram"
          aria-current="page"
        >
          Import Assortment Planogram
        </Link>
      </Breadcrumbs>
      <h2 style={{ textAlign: "center", marginTop: "21px" }}>
        Import Assortment Planogram
      </h2>

      <Container>
        <form style={{ padding: "39px" }}>
          <FormGroup row>
            <button
              onClick={handleImport}
              type="submit"
              style={{
                color: "white",
                background: "#1b5e20",
                padding: "15px",
                width: "-webkit-fill-available",
                borderRadius: "5px",
                border: "none",
                margin: "20px",
                cursor: "pointer",
              }}
            >
              <b>SUBMIT ASSORTMENT PLANOGRAM FILE</b>
            </button>

            <Col xs={4} sm={8} lg={10}>
              <InputGroup>
                <InputGroupAddon addonType="prepend">
                  <Button
                    color="info"
                    style={{
                      color: "white",
                      zIndex: 0,
                      border: "none",
                      width: "-webkit-fill-available",
                      background: "#9c27b0",
                      padding: "15px",
                      borderRadius: "5px",
                      margin: "20px",
                      cursor: "pointer",
                    }}
                    onClick={openFileBrowser}
                  >
                    <i className="cui-file"></i>{" "}
                    <b>BROWSE ASSORTMENT PLANOGRAM FILE&hellip;</b>
                  </Button>
                  <input
                    type="file"
                    hidden
                    onChange={fileHandler}
                    ref={fileInput}
                    onClick={(event) => {
                      event.target.value = null;
                    }}
                    style={{ padding: "10px" }}
                  />
                </InputGroupAddon>
                <Input
                  type="text"
                  className="form-control"
                  value={uploadedFileName}
                  readOnly
                  invalid={isFormInvalid}
                  style={{
                    width: "-webkit-fill-available",
                    padding: "10px",
                    borderRadius: "5px",
                    margin: "20px",
                    border: "0px solid",
                  }}
                />
                {!dataLoaded && (
                  <FormFeedback>
                    <Fade
                      in={isFormInvalid}
                      tag="h4"
                      style={{
                        fontStyle: "italic",
                        margin: "20px",
                        color: "#c62828",
                      }}
                    >
                      Please select a .xlsx file only !
                    </Fade>
                  </FormFeedback>
                )}
              </InputGroup>
            </Col>
          </FormGroup>
        </form>

        {dataLoaded && (
          <div>
            <Card body outline color="secondary" className="restrict-card">
              <OutTable
                data={rows}
                columns={cols}
                tableClassName="ExcelTable2007"
                tableHeaderRowClass="heading"
              />
            </Card>
          </div>
        )}
      </Container>
    </div>
  );
};

export default ImportPlanogram;
